export function isTelegramEnv() {
  if (typeof window === 'undefined') {
    return false
  }

  const initData = window.Telegram?.WebApp?.initData
  return typeof initData === 'string' && initData.trim().length >= 10
}

export function isLogoutAllowed() {
  return !(process.env.NODE_ENV === 'production' && isTelegramEnv())
}
